import { SCHOOL_LISTINGS_USER_ACTION } from 'consts';

const STORAGE_KEY = 'schoolListingsUserAction';

export function setPendingSchoolListingsUserAction(
  userAction: SCHOOL_LISTINGS_USER_ACTION
): void {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(STORAGE_KEY, userAction);
  }
}

export function consumePendingSchoolListingsUserAction():
  | SCHOOL_LISTINGS_USER_ACTION
  | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const value = sessionStorage.getItem(
    STORAGE_KEY
  ) as SCHOOL_LISTINGS_USER_ACTION | null;

  if (value) {
    sessionStorage.removeItem(STORAGE_KEY);
  }

  return value || undefined;
}

export function setSchoolListingsUserActionForSearchLink(
  url: string,
  userAction: SCHOOL_LISTINGS_USER_ACTION
): void {
  if (url.includes('/portal/search')) {
    setPendingSchoolListingsUserAction(userAction);
  }
}
